import { Fragment, type ReactNode } from "react";

/**
 * Renders free-text user-generated content (FAIL-453: the `/map/` owner
 * description) with any absolute URLs turned into real anchors carrying
 * `rel="nofollow ugc"` — Google's UGC link-attribute pair for exactly this
 * shape of content (an owner-authored snippet we don't editorially review),
 * so an arbitrary link a map owner types in doesn't pass SEO authority.
 * Plain text otherwise; no markdown/HTML parsing (the field is plain text).
 */

const URL_RE = /https?:\/\/[^\s<>"']+/g;

export function linkifyUgc(text: string, className?: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let key = 0;
  URL_RE.lastIndex = 0;
  while ((match = URL_RE.exec(text)) !== null) {
    const url = match[0];
    if (match.index > lastIndex) nodes.push(<Fragment key={key++}>{text.slice(lastIndex, match.index)}</Fragment>);
    nodes.push(
      <a key={key++} href={url} className={className} rel="nofollow ugc noopener noreferrer" target="_blank">
        {url}
      </a>,
    );
    lastIndex = match.index + url.length;
  }
  if (lastIndex < text.length) nodes.push(<Fragment key={key++}>{text.slice(lastIndex)}</Fragment>);
  return nodes;
}
